import { useColorMode, useSetColorMode } from '@atlaskit/app-provider';
import { useEffect } from 'react';

export const useDarkMode = () => {
	const colorMode = useColorMode();
	const setColorMode = useSetColorMode();

	useEffect(() => {
		if (colorMode !== 'dark') {
			setColorMode('dark');
		}
	}, [colorMode, setColorMode]);
};
